import { derived } from 'svelte/store'

import {
  blueridge, 
  pharma, 
  holdings, 
  averageaward, 
  labs, 
  restotalindustryfunding, 
  cores 
} from '../dataPromisesMenu'

import fetchStore from '../utilities/fetchStore'

const regex = /\$|\,/g

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    blueridge: blueridge,
    pharma: pharma,
    holdings: holdings,
    averageaward: averageaward,
    labs: labs,
    restotalindustryfunding: restotalindustryfunding,
    cores: cores
  }
  
  const [data, loading, error] = fetchStore(dataCalls)

  const blueridgeDerived = derived(data, ($data)=>{
    console.log('a look at $data', $data)
    if($data.blueridge) {
      return Object.entries($data.blueridge)
    } else {
      return []
    }
  }, [])

  const pharmaDerived = derived(data, ($data)=>{
    if($data.pharma) {
      return Object.entries($data.pharma)
    } else {
      return []
    }
  }, [])

  const holdingsDerived = derived(data, ($data)=>{
    if($data.holdings) {
      return Object.entries($data.holdings)
    } else {
      return []
    }
  }, [])

  const averageawardDerived = derived(data, ($data)=>{
    if($data.averageaward) {
      return Object.entries($data.averageaward)
    } else {
      return []    }
  }, [])

  const labsDerived = derived(data, ($data)=>{
    if($data.labs) {
      return Object.entries($data.labs)
    } else {
      return []
    }
  }, [])

  const restotalindustryfundingDerived = derived(data, ($data)=>{
    if($data.restotalindustryfunding) {
      return Object.entries($data.restotalindustryfunding)
    } else {
      return []
    }
  }, [])

  const coresDerived = derived(data, ($data)=>{
    console.log('$data.cores, as it\'s getting here', $data.cores)
    if($data.cores) {
      return Object.entries($data.cores)
    } else {
      return []
    }
  }, [])
  
  return [
    data, 
    loading,
    error,

    blueridgeDerived,
    pharmaDerived,
    holdingsDerived,
    averageawardDerived,
    labsDerived,
    restotalindustryfundingDerived,
    coresDerived
  ]
}